export default {
    default: {
        fetchModelsPeriod: 60000
    },
    listModels: {
        user: {
            url: 'user/',
        },
        site: {
            url: 'site/',
            filter: {
                ordering: '-creation_date',
                archived: false
            }
        },
        motors: {
            url: 'motor/',
            filter: {
                archived: false
            }
        },
        simulations: {
            fetch: false,
            url: 'simulation/',
            filter: {
                archived: false
            }
        },
        simulationAssets: {
            url: 'simulation-asset/',
        },
        simulationUsages: {
            url: 'simulation-usage/',
        },
    }
};



// WEBPACK FOOTER //
// ./src/store/meta.js